export default {
    ecommerce: {
        currencyCode: 'PLN',
        remove: {
            products: [],
        },
    },
    event: 'removeFromCart',
};
